import React from 'react';
import { Product } from '../types/types';
import { Link } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { renderProductName } from '../utils/productName';
import './ProductList.css';

type ProductListProps = {
  products: Product[];
  category: 'food' | 'drinks';
};

const ProductList: React.FC<ProductListProps> = ({ products, category }) => {
  const { addToCart, cartItems } = useCart();
  const sortedProducts = [...products];

  const getCartQuantity = (productId: string): number => {
    return cartItems
      .filter(item => item.productId === productId)
      .reduce((total, item) => total + item.quantity, 0);
  };

  const handleDirectAddToCart = (product: Product) => {
    addToCart({
      productId: product.id,
      productName: product.name,
      selectedOption: { name: product.name, price: product.basePrice },
      quantity: 1,
      category
    });
  };

  return (
    <div className="product-list">
      {sortedProducts.map(product => {
        const hasOptions = product.options && product.options.length > 0;
        const style = product.color ? { backgroundColor: `${product.color}80` } : {};
        const cartQuantity = getCartQuantity(product.id);
        const rightSide = (
          <>
            <div className="product-price">{product.basePrice.toFixed(2)} €</div>
            {cartQuantity > 0 && (
              <div className="product-cart-quantity">{cartQuantity}x</div>
            )}
          </>
        );
        if (hasOptions) {
          return (
            <Link
              to={`/product/${category}/${product.id}`}
              key={product.id}
              className="product-item"
              style={style}
            >
              <div className="product-name">{renderProductName(product.name)}</div>
              <div className="product-right">{rightSide}</div>
            </Link>
          );
        } else {
          return (
            <div
              key={product.id}
              className="product-item"
              style={style}
              onClick={() => handleDirectAddToCart(product)}
            >
              <div className="product-name">{renderProductName(product.name)}</div>
              <div className="product-right">{rightSide}</div>
            </div>
          );
        }
      })}
    </div>
  );
};


export default ProductList;
